
import AdjacencySettingsService from './AdjacencySettingsService';

export { default } from './AdjacencySettingsService';
export const adjacencySettingsService = new AdjacencySettingsService();